interface Scheduler {
  postTask: (fn: () => void, opts: { priority: string }) => Promise<void>;
}

declare const scheduler: Scheduler | undefined;

export function scheduleTask(
  fn: () => void,
  priority: 'user-blocking' | 'user-visible' | 'background' = 'background'
): void {
  if (typeof scheduler !== 'undefined' && 'postTask' in scheduler) {
    void scheduler.postTask(fn, { priority });
  } else {
    setTimeout(fn, 0);
  }
}
